<div class="descriptionList d-md-flex" [class.d-none]="hiddenSmDList">
  <div class="descriptionList__column">
    <div class="descriptionList__block">
      <h3 class="descriptionList__block__title vc-text-l" i18n="@@PRODUCT.DESCRIPTION.DETAILS.TITLE_INFOS">Details</h3>
      <ul class="descriptionList__block__list descriptionList__block__list--detail">
        <li>
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.ON_LINE_SINCE">Online from:</ng-container>
          {{ product.creationDate | date: 'dd/MM/yyyy':'GMT-1' }}
        </li>
        <li>
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.UNIVERSE">Universe:</ng-container>
          {{ product.universe?.localizedName }}
        </li>
        <li>
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.CATEGORY">Category:</ng-container>
          {{ product.category?.parent?.localizedName }}
        </li>
        <li *ngIf="product.category?.localizedName">
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.SUBCATEGORY">Sub-category:</ng-container>
          {{ product.category.localizedName }}
        </li>
        <li>
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.BRAND">Designer:</ng-container> {{ product.brand?.name }}
        </li>
        <li *ngIf="product.model?.localizedName">
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.MODEL">Model:</ng-container>
          {{ product.model.localizedName }}
        </li>
        <li>
          <span>
            <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.CONDITION">Condition:</ng-container>
            {{ product.condition?.description }}</span
          >
          <button
            class="descriptionList__block__list__moreInfo vc-link vc-text-m"
            (click)="conditionGuideModalComponent()"
            i18n="@@PRODUCT.DETAILS.MORE_INFO"
          >
            More infos
          </button>
        </li>
        <li>
          <span
            *ngIf="product.watchStrapMaterial; else parentMaterial"
            i18n="@@PRODUCT.DESCRIPTION.DETAILS.MATERIAL_BOX"
            >Housing material:
          </span>

          <ng-template #parentMaterial>
            <ng-container *ngIf="product.material?.parent?.localizedName; else material">
              <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.MATERIAL">Material:</ng-container>
              {{ product.material.parent.localizedName }}
            </ng-container>
          </ng-template>
          <ng-template #material>
            <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.MATERIAL">Material:</ng-container>
            {{ product.material?.localizedName }}
          </ng-template>
        </li>
        <li *ngIf="product.watchStrapMaterial">
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.MATERIAL_WATCHSTRAP">Bracelet material:</ng-container>
          {{ product.watchStrapMaterial.localizedName }}
        </li>
        <li *ngIf="product.watchMechanism">
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.MECHANISM">Mechanism:</ng-container>
          {{ product.watchMechanism.localizedName }}
        </li>
        <li *ngIf="product.color">
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.COLOR">Color:</ng-container>
          {{ product.color?.localizedName }}
        </li>
        <li *ngIf="product.pattern">
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.PATTERN">Pattern:</ng-container>
          {{ product.pattern.localizedName }}
        </li>
        <li *ngIf="product.size">
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.SIZE">Size:</ng-container> {{ product.size.size }}
          {{ product.size?.localizedStandard }}
          <button
            *ngIf="sizeGuide?.guide.length > 0"
            (click)="openSizeGuideModal()"
            class="productDetails__moreInfoLink vc-link vc-text-m"
            i18n="@@PRODUCT.DETAILS.SIZES_GUIDE"
          >
            size guide
          </button>
        </li>
        <li *ngIf="vintage">
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.STYLE">Style:</ng-container>
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.VINTAGE">Vintage</ng-container>
        </li>
        <li *ngIf="shipping">
          <ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.LOCALISATION">Location:</ng-container>
          <span *ngIf="product.inStock; else fromSeller" i18n="@@PRODUCT.DESCRIPTION.DETAILS.PRODUCT_LOCALISATION_VC"
            >Vestiaire Collective {{ shipping.warehouse.localizedName }}</span
          >
          <ng-template #fromSeller i18n="@@PRODUCT.DETAILS.PRODUCT_LOCALISATION"
            >{{ product.seller.country }}, from the seller {{ product.seller.firstname }}</ng-template
          >
        </li>
        <li><ng-container i18n="@@PRODUCT.DESCRIPTION.DETAILS.REFERENCE">Reference:</ng-container> {{ product.id }}</li>
      </ul>
    </div>
  </div>
  <div class="descriptionList__column">
    <!-- description__details DIMENSIONS -->
    <div *ngIf="product.measurements" class="descriptionList__block descriptionList__block--dimensions">
      <h3 class="descriptionList__block__title" i18n="@@PRODUCT.DESCRIPTION.DETAILS.TITLE_DIMENSIONS">Measurements</h3>
      <ul class="descriptionList__block__list">
        <li *ngFor="let measurement of product.measurements" i18n="@@PRODUCT.DESCRIPTION.DETAILS.DIMENSION_DETAIL">
          {{ measurement.localizedName }}: {{ measurement.value }} {{ product.unit }}
        </li>
      </ul>
    </div>
    <!-- description__details PACKAGING -->
    <div *ngIf="product.packagings" class="descriptionList__block descriptionList__block--packaging">
      <h3 class="descriptionList__block__title" i18n="@@PRODUCT.DESCRIPTION.DETAILS.TITLE_PACKAGING">Sold with</h3>
      <ul class="descriptionList__block__list">
        <li *ngFor="let packaging of product.packagings">{{ packaging.localizedName }}</li>
      </ul>
    </div>
  </div>
</div>
<button
  class="d-md-none descriptionList__btnDisplay vc-btn vc-btn--medium vc-btn--full vc-btn--primary"
  (click)="toggleDescriptionList()"
  [class.vc-btn--primary]="!hiddenSmDList"
  [class.vc-btn--secondary]="hiddenSmDList"
>
  <span [class.d-none]="!hiddenSmDList" i18n="@@PRODUCT.DESCRIPTION.DETAILS.SHOW_DETAILS_BTN">See more details</span>
  <span [class.d-none]="hiddenSmDList" i18n="@@PRODUCT.DESCRIPTION.DETAILS.HIDE_DETAILS_BTN">Hide details</span>
</button>
